import { DsUsersFilterOrderBy } from '../ds-users-index';
import { DsUsersFiltersInterface } from '../interfaces/ds-users-filters.interface';

export class DsUsersFiltersModel implements DsUsersFiltersInterface {
  /**
   * Users search filters.
   */
  public search? = '';

  /**
   * Users orderBy filters.
   */
  public orderBy?: DsUsersFilterOrderBy;

  /**
   * Users orderSort filters;
   */
  public orderSort?: '' | 'asc' | 'desc' = '';

  /**
   * Users pageNumber filters
   */
  public pageIndex?: number;

  /**
   * Users numPerPage filters
   */
  public numPerPage?: number;

  /**
   * Create an instance of DsUsersFiltersModel.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsUsersFiltersInterface) {
    if (jsonData) {
      this.search = jsonData.search || this.search;
      this.orderBy = jsonData.orderBy;
      this.orderSort = jsonData.orderSort || this.orderSort;
      this.pageIndex = jsonData.pageIndex;
      this.numPerPage = jsonData.numPerPage;
    }
  }
}
